import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { AppDispatch, RootState } from 'redux/store';
import { loadDocs } from 'redux/application/documents/documents-middleware';
import { setSelectedApplication } from 'redux/v2/selectedApplication.reducer';
import { fetchTickets } from 'redux/v2/tickets';

const useActiveApplication = () => {
    const params = useParams();
    const dispatch: AppDispatch = useDispatch();

    const { selectedApplication } = useSelector((state: RootState) => state.selectedApplication);
    const { applications, loading: loadingStatus } = useSelector(
        (state: RootState) => state.applications
    );
    const { tickets, loading: loadingTickets } = useSelector((state: RootState) => state.tickets);

    const loading = loadingStatus === 'pending';
    const selectedApplicationId = Number(params.id);

    useEffect(() => {
        if (applications.length === 0) {
            return;
        }

        const currentIsValid = applications.some(
            (app) => String(app.id) === String(selectedApplication)
        );
        if (currentIsValid) {
            return;
        }

        const matchedApplication = applications.find((app) => app.id === selectedApplicationId);
        const applicationId = matchedApplication ? matchedApplication.id : applications[0].id;
        dispatch(setSelectedApplication(applicationId));
        dispatch(loadDocs(`${applicationId}`));
        dispatch(fetchTickets(`${applicationId}`));
    }, [applications, dispatch, selectedApplication, selectedApplicationId]);

    return {
        selectedApplicationId: selectedApplication,
        loading,
        applications,
        tickets,
        loadingTickets,
    };
};

export default useActiveApplication;
